import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { BaseModel } from '../models/base.model';
import { LoggerService } from '../services/logger.service';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-master-management',
  templateUrl: './master-management.component.html',
  styleUrls: ['./master-management.component.scss']
})
export class MasterManagementComponent implements OnInit {
  selectedEntity: BaseModel | null = null;
  selectedEntityData: any = {};
  refreshTrigger: boolean = false;
  
  // Estado del cajón de roles
  isRoleDrawerOpen: boolean = false;

  // NUEVO: Estado del Entorno
  isGlobalMode: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef, 
    private logger: LoggerService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    // Verificamos si estamos en el centro de control principal (Sin tenant suplantado)
    this.isGlobalMode = this.authService.isSuperAdmin() && !this.authService.getActiveTenantId();
  }

  onEntitySelected(entity: BaseModel) {
    this.selectedEntity = entity;
    this.selectedEntityData = {};
    this.isRoleDrawerOpen = false; // Cerramos el cajón al cambiar de maestro
  }

  onRowSelected(entityData: any) {
    this.selectedEntityData = {}; 
    this.selectedEntityData = entityData;
    
    // Auto-abrir el cajón si estamos en usuarios y seleccionamos uno
    if (this.selectedEntity?.constructor.name === 'User') {
      this.isRoleDrawerOpen = true;
    }
    
    this.cdr.detectChanges(); 
  }

  onEntitySaved() {
    this.logger.info("MasterManagementComponent.onEntitySaved");
    this.refreshTrigger = !this.refreshTrigger;
    this.selectedEntityData = {};
    this.isRoleDrawerOpen = false; // Cerramos para obligar a seleccionar de nuevo
  }

  onFormReset() {
    this.selectedEntityData = {}; 
    this.isRoleDrawerOpen = false; // Cerramos si limpian el formulario
  }

  toggleRoleDrawer() {
    this.isRoleDrawerOpen = !this.isRoleDrawerOpen;
  }
}